import { AuthGuard, configurationAuthScope, CrudOp } from "@org-avp/avp-avengers-ui-shared-auth";
import { useRequiredProjectParam, useRequiredSubprojectParam } from "@org-avp/avp-avengers-ui-shared-store";
import { importView } from "@org-avp/avp-avengers-ui-shared-utils";
import { FC, lazy, Suspense } from "react";

export const PrFamilyInfoView: FC = () => {
  const projectId = useRequiredProjectParam("projectId");
  const subprojectId = useRequiredSubprojectParam("subprojectId");
  const brand = useRequiredProjectParam("brand");
  const modelYear = parseInt(useRequiredSubprojectParam("modelYear"));
  const mbvKeys = useRequiredSubprojectParam("mbvKeys", parseArrayAndSort);
  return (
    <AuthGuard authScope={configurationAuthScope} crudOp={CrudOp.READ} brand={brand}>
      <Suspense><LazyPrFamilyInfoView projectId={projectId} subprojectId={subprojectId} brand={brand} modelYear={modelYear} mbvKeys={mbvKeys}/></Suspense>
    </AuthGuard>
  );
};

const LazyPrFamilyInfoView = lazy(importView(
  () => import("../components/PrFamilyInfoView"),
  (it) => it.PrFamilyInfoView,
));

const parseArrayAndSort = (param: string): string[] => {
  return param.split(",").sort();
};
